import { captureMessage, captureException, withScope } from '@sentry/browser';
export const logger = {
    debug(message) {
        // eslint-disable-next-line no-console
        console.debug(message);
        return undefined;
    },
    info(message) {
        // eslint-disable-next-line no-console
        console.info(message);
        return undefined;
    },
    warn(message) {
        withScope((scope) => {
            scope.setLevel('warning');
            captureMessage(message);
        });
        // eslint-disable-next-line no-console
        console.warn(message);
        return undefined;
    },
    error: (error) => {
        withScope((scope) => {
            scope.setLevel('error');
            scope.setExtras({
                error,
            });
            captureException(error);
        });
        // eslint-disable-next-line no-console
        console.error(error);
        return undefined;
    },
};
//# sourceMappingURL=index.js.map